import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { pushNotification } from "../../utils/notifications";

export default function ClearLocalStorage() {
    const navigate = useNavigate();

    const handleClearLocalStorage = () => {
        localStorage.clear();
        navigate("/", { replace: true });
        window.location.reload();
        pushNotification("Local settings have been cleared.", "success");
    }

    useEffect(() => {
        handleClearLocalStorage();
    }, []);
    
    return (
        <Box m="20px">
            Local settings have been cleared.
        </Box>
    );
}
